export enum NotificationTargetGroup {
  TESTING = 'TESTING',
  PRODUCTION = 'PRODUCTION'
}
